import sortBy from 'lodash/sortBy';
import { fetchApi } from 'shared/functions';

export const fetchCountries = () =>
  fetchApi(`/storefront/config/countries`)
    .then(response => response.json())
    .then(({ data }) => sortBy(data, 'name'));

export const fetchEntitiesCountries = ({ query }) =>
  fetchApi(`/storefront/issuers/countries?query=${query}`)
    .then(response => response.json())
    .then(({ data }) => sortBy(data, 'name'));

export const fetchInstrumentsCountries = ({ query }) =>
  fetchApi(`/storefront/issues/countries?query=${query}`)
    .then(response => response.json())
    .then(({ data }) => sortBy(data, 'name'));

export const fetchEsgRegions = () =>
  fetchApi(`/esg/api/esg-regions/`)
    .then(response => response.json())
    .then(({ data }) => sortBy(data, 'name'));

export const fetchCountryRegions = ({ iso }) => {
  const resourceUrl = '/sig/api/regions/';
  const params = {
    method: 'POST',
    body: JSON.stringify({ iso }),
  };

  return fetchApi(resourceUrl, params).then(response => response.json());
};
